import React from 'react';

interface FormSectionProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}

export const FormSection: React.FC<FormSectionProps> = ({
  children,
  variant = 'secondary',
  className = '',
}) => {
  const baseClasses = 'rounded-lg p-6 border transition-all';
  const variantClasses =
    variant === 'primary'
      ? 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-400 dark:border-yellow-700/50 hover:border-yellow-500 dark:hover:border-yellow-600'
      : 'bg-white dark:bg-white/5 border-gray-300 dark:border-white/15 hover:border-gray-400 dark:hover:border-white/25';

  return <div className={`${baseClasses} ${variantClasses} ${className}`}>{children}</div>;
};
